import { type PlayerState, ScrollPosition } from "./types";

export const playerInitialState: PlayerState = {
	volume: {
		volumeBarDisplayed: false,
		muted: false,
	},
	currentSong: null,
	lastSong: {
		disableFeatures: false,
		song: null,
	},
	waitingList: [],
	waitingListPosition: ScrollPosition.TOP,
	isWaitlingListSongDragging: false,
	currentSongEndTimestampInSecond: 0,
	musicPitchValue: 0,
};
